var _defs, _polygon, _polygon2, _polygon3, _polygon4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 559.57 966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -4.64,
    y1: 947.2,
    x2: 287.32,
    y2: 471.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8d24f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fde759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 262.5,
    y1: 511.87,
    x2: 543.68,
    y2: 29.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2bb09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fbdc2e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -4.64,
    y1: 947.2,
    x2: 287.32,
    y2: 471.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f18996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6b3b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 262.5,
    y1: 511.87,
    x2: 543.68,
    y2: 29.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e94167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f2939d"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1.38 321.45 559.57 643.73 1.38 966 1.38 321.45",
    fill: "url(#a)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "558.2 0 0 322.27 558.2 644.55 558.2 0",
    fill: "url(#b)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "1.38 321.45 559.57 643.73 1.38 966 1.38 321.45",
    fill: "url(#c)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "558.2 0 0 322.27 558.2 644.55 558.2 0",
    fill: "url(#d)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrex);
export default __webpack_public_path__ + "static/media/strex.d5db5d82a3e84796ab2db4dab927f57e.svg";
export { ForwardRef as ReactComponent };